import { ReactNode } from "react";

import { ProductReminderModal } from "shared/product/ProductSection/ProductSpecifications/shared/ProductReminderModal";

type WithProductReminderModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  productName: string;
  subscriptionId: number;
  children: ReactNode;
};

export const WithProductReminderModal = ({
  isOpen,
  closeModal,
  productName,
  subscriptionId,
  children,
}: WithProductReminderModalProps) => {
  return (
    <>
      <ProductReminderModal
        closeModal={closeModal}
        isOpen={isOpen}
        isComingSoon
        productName={productName}
        subscriptionId={subscriptionId}
      />
      {children}
    </>
  );
};
